export const mockPropertiesData = [
    {
        id: 1,
        image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800',
        title: 'Căn hộ cao cấp Vista Verde',
        location: 'Quận 2, TP. Hồ Chí Minh',
        price: '8.5 tỷ',
        priceValue: 8500000000,
        bedrooms: 3,
        bathrooms: 2,
        area: 120,
        rating: 4.8,
        badge: 'Nổi bật',
        type: 'apartment'
    },
    {
        id: 2,
        image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800',
        title: 'Biệt thự hiện đại Thảo Điền',
        location: 'Quận 2, TP. Hồ Chí Minh',
        price: '25 tỷ',
        priceValue: 25000000000,
        bedrooms: 5,
        bathrooms: 4,
        area: 300,
        rating: 4.9,
        badge: 'Hot',
        type: 'villa'
    },
    {
        id: 3,
        image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800',
        title: 'Nhà phố thương mại Sunrise City',
        location: 'Quận 7, TP. Hồ Chí Minh',
        price: '15 tỷ',
        priceValue: 15000000000,
        bedrooms: 4,
        bathrooms: 3,
        area: 200,
        rating: 4.7,
        badge: 'Mới',
        type: 'house'
    },
    {
        id: 4,
        image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800',
        title: 'Căn hộ duplex The EverRich',
        location: 'Quận 5, TP. Hồ Chí Minh',
        price: '12 tỷ',
        priceValue: 12000000000,
        bedrooms: 4,
        bathrooms: 3,
        area: 180,
        rating: 4.6,
        badge: 'Giảm giá',
        type: 'apartment'
    },
    {
        id: 5,
        image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800',
        title: 'Penthouse Diamond Island',
        location: 'Quận 2, TP. Hồ Chí Minh',
        price: '35 tỷ',
        priceValue: 35000000000,
        bedrooms: 4,
        bathrooms: 4,
        area: 250,
        rating: 5.0,
        badge: 'Hot',
        type: 'apartment'
    },
    {
        id: 6,
        image: 'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=800',
        title: 'Nhà vườn Thủ Đức',
        location: 'Thủ Đức, TP. Hồ Chí Minh',
        price: '18 tỷ',
        priceValue: 18000000000,
        bedrooms: 5,
        bathrooms: 3,
        area: 280,
        rating: 4.5,
        type: 'house'
    },
    {
        id: 7,
        image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800',
        title: 'Căn hộ The Sun Avenue',
        location: 'Quận 2, TP. Hồ Chí Minh',
        price: '4.2 tỷ',
        priceValue: 4200000000,
        bedrooms: 2,
        bathrooms: 2,
        area: 75,
        rating: 4.4,
        badge: 'Mới',
        type: 'apartment'
    },
    {
        id: 8,
        image: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800',
        title: 'Biệt thự Phú Mỹ Hưng',
        location: 'Quận 7, TP. Hồ Chí Minh',
        price: '32 tỷ',
        priceValue: 32000000000,
        bedrooms: 6,
        bathrooms: 5,
        area: 400,
        rating: 4.9,
        badge: 'Nổi bật',
        type: 'villa'
    },
    {
        id: 9,
        image: 'https://images.unsplash.com/photo-1600585154363-67eb9e2e2099?w=800',
        title: 'Nhà phố Bình Thạnh',
        location: 'Bình Thạnh, TP. Hồ Chí Minh',
        price: '9.8 tỷ',
        priceValue: 9800000000,
        bedrooms: 3,
        bathrooms: 3,
        area: 150,
        rating: 4.3,
        type: 'house'
    },
    {
        id: 10,
        image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800',
        title: 'Căn hộ Vinhomes Central Park',
        location: 'Bình Thạnh, TP. Hồ Chí Minh',
        price: '6.5 tỷ',
        priceValue: 6500000000,
        bedrooms: 2,
        bathrooms: 2,
        area: 90,
        rating: 4.7,
        badge: 'Giảm giá',
        type: 'apartment'
    },
    {
        id: 11,
        image: 'https://images.unsplash.com/photo-1600585154084-4e5fe7c39198?w=800',
        title: 'Đất nền Quận 9',
        location: 'Quận 9, TP. Hồ Chí Minh',
        price: '5.5 tỷ',
        priceValue: 5500000000,
        bedrooms: 0,
        bathrooms: 0,
        area: 100,
        rating: 4.2,
        type: 'land'
    },
    {
        id: 12,
        image: 'https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?w=800',
        title: 'Biệt thự An Phú An Khánh',
        location: 'Quận 2, TP. Hồ Chí Minh',
        price: '28 tỷ',
        priceValue: 28000000000,
        bedrooms: 5,
        bathrooms: 4,
        area: 350,
        rating: 4.8,
        badge: 'Hot',
        type: 'villa'
    }
];

export const propertyTypesData = [
    { value: 'all', label: 'Tất cả' },
    { value: 'apartment', label: 'Căn hộ' },
    { value: 'house', label: 'Nhà riêng' },
    { value: 'villa', label: 'Biệt thự' },
    { value: 'land', label: 'Đất nền' }
];

export const locationsData = [
    'Quận 1',
    'Quận 2',
    'Quận 3',
    'Quận 5',
    'Quận 7',
    'Quận 9',
    'Thủ Đức',
    'Bình Thạnh',
    'Phú Nhuận'
];
